import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

import allocabLogo from '../assets/images/allocab-logo.svg';
import { BaseButton } from '../components/button/BaseButton';
import { PrimaryButton } from '../components/button/PrimaryButton';
import { useAuth } from '../hooks/useAuth';
import { t } from '../services/translation/translation';

export const ForgetRoute = () => {
  const [email, setEmail] = useState('');
  const { resetPasswordMutation } = useAuth();
  const handleResetPassword = async () => {
    resetPasswordMutation.mutateAsync({ email: email });
  };

  return (
    <div className="h-[calc(100vh_-_3rem)] overflow-y-auto">
      <Helmet>
        <title>{t('forget-route.meta-title')}</title>
      </Helmet>
      <video
        className="hidden md:block fixed bottom-0 right-0 z-[-100] min-w-full min-h-full w-auto h-auto object-cover"
        preload="none"
        autoPlay
        loop
        muted
      >
        <source
          src="//storage.googleapis.com/allocab_prod_apps/webapp/media/stock-footage-out-of-focus-city-traffic-at-night-car-headlights-and-tail-lights-out-of-focus.mov"
          type="video/mp4"
        />
      </video>
      <div className="flex min-h-full flex-col justify-center pb-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-background p-4 shadow sm:px-10 md:opacity-90">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
              <img className="mx-auto h-16 w-auto" src={allocabLogo} alt="allocab" />
              <h2 className="my-6 text-center text-3xl font-bold tracking-tight ">{t('login.welcome')}</h2>
            </div>
            <hr className="my-6" />
            <div>
              <strong className=" text-xl flex justify-center mb-3">{t('login.forgotten-title')}</strong>
            </div>
            <div className="">
              {resetPasswordMutation.isSuccess ? (
                <div className="flex justify-center">
                  <span className="text-green-500">{t('login.forgotten-success')}</span>
                </div>
              ) : (
                <>
                  <div className="flex justify-center">{t('login.forgotten-explanation')}</div>
                  <div className="my-8">
                    <input
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      placeholder="jean@allocab.com"
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      required
                      className="block w-full border-0 py-1.5 shadow-sm ring-1 ring-inset focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                    />
                  </div>
                  <div>
                    <PrimaryButton
                      className="w-full"
                      onClick={() => handleResetPassword()}
                      isLoading={resetPasswordMutation.isLoading}
                    >
                      {t('login.send')}
                    </PrimaryButton>
                  </div>
                </>
              )}
              <hr className="mt-6" />
              <div className="flex justify-center">
                <Link className="text-primary cursor-pointer mt-5" to={`/login`}>
                  {t('login.connect')}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
